import r from "../../shared-lib/braze-shared-lib.js";
export function logDeprecationWarning(e, a, i) {
  let s = `The '${e}' ${a} is deprecated.`;
  i && (s += ` Please use '${i}' instead.`), r.j.warn(s);
}
